// Import store
import { store } from '../store'

import Config from '@/config'
import Home from '@/views/Home'
import PageError from '@/views/PageError'
import PageNotFound from '@/views/PageNotFound'

const About = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "service" */ '@/views/service/About.vue')
const Contacts = () =>
	import(/* webpackPrefetch: true */ /* webpackChunkName: "service" */ '@/views/service/Contacts.vue')
const ExecutiveSummary = () =>
	import(/* webpackPrefetch: true */ /* webpackChunkName: "service" */ '@/views/service/ExecutiveSummary.vue')
const FaqLawyer = () =>
	import(/* webpackPrefetch: true */ /* webpackChunkName: "service" */ '@/views/service/FaqLawyer.vue')
const FaqUser = () =>
	import(/* webpackPrefetch: true */ /* webpackChunkName: "service" */ '@/views/service/FaqUser.vue')
const HowToLawyer = () =>
	import(/* webpackPrefetch: true */ /* webpackChunkName: "service" */ '@/views/service/HowToLawyer.vue')
const HowToUser = () =>
	import(/* webpackPrefetch: true */ /* webpackChunkName: "service" */ '@/views/service/HowToUser.vue')
const Partners = () =>
	import(/* webpackPrefetch: true */ /* webpackChunkName: "service" */ '@/views/service/Partners.vue')
const Pricing = () =>
	import(/* webpackPrefetch: true */ /* webpackChunkName: "service" */ '@/views/service/Pricing.vue')
const TermsAndConditions = () =>
	import(/* webpackPrefetch: true */ /* webpackChunkName: "service" */ '@/views/service/TermsAndConditions.vue')

const Login = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "auth" */ '@/views/auth/Login.vue')
const Logout = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "auth" */ '@/views/auth/Logout.vue')
const MailConfirmChange = () =>
	import(/* webpackPrefetch: true */ /* webpackChunkName: "notify" */ '@/views/auth/MailConfirmChange.vue')
const MailConfirmLawyer = () =>
	import(/* webpackPrefetch: true */ /* webpackChunkName: "notify" */ '@/views/auth/MailConfirmLawyer.vue')
const MailConfirmUser = () =>
	import(/* webpackPrefetch: true */ /* webpackChunkName: "notify" */ '@/views/auth/MailConfirmUser.vue')
const MailNotify = () =>
	import(/* webpackPrefetch: true */ /* webpackChunkName: "notify" */ '@/views/auth/MailNotify.vue')
const PasswordRecovery = () =>
	import(/* webpackPrefetch: true */ /* webpackChunkName: "auth" */ '@/views/auth/PasswordRecovery.vue')
const PasswordReset = () =>
	import(/* webpackPrefetch: true */ /* webpackChunkName: "auth" */ '@/views/auth/PasswordReset.vue')
const RegisterLawyer = () =>
	import(/* webpackPrefetch: true */ /* webpackChunkName: "auth" */ '@/views/auth/RegisterLawyer.vue')
const RegisterUser = () =>
	import(/* webpackPrefetch: true */ /* webpackChunkName: "auth" */ '@/views/auth/RegisterUser.vue')

const NewsletterUnsubscribe = () => import(/* webpackPrefetch: true */ '@/views/misc/NewsletterUnsubscribe.vue')

const ArticlesDetail = () =>
	import(/* webpackPrefetch: true */ /* webpackChunkName: "service" */ '@/views/core/articles/ArticlesDetail.vue')
const CreditsList = () =>
	import(/* webpackPrefetch: true */ /* webpackChunkName: "account" */ '@/views/core/credits/CreditsList.vue')
const FeedbacksList = () =>
	import(/* webpackPrefetch: true */ /* webpackChunkName: "account" */ '@/views/core/feedbacks/FeedbacksList.vue')
const LandingsDetail = () =>
	import(/* webpackPrefetch: true */ /* webpackChunkName: "service" */ '@/views/core/landings/LandingsDetail.vue')
const MessagesList = () =>
	import(/* webpackPrefetch: true */ /* webpackChunkName: "account" */ '@/views/core/messages/MessagesList.vue')
const RequestTypesDetail = () =>
	import(/* webpackPrefetch: true */ /* webpackChunkName: "service" */ '@/views/core/types/RequestTypesDetail.vue')
const RequestTypesList = () =>
	import(/* webpackPrefetch: true */ /* webpackChunkName: "service" */ '@/views/core/types/RequestTypesList.vue')
const RequestsDetail = () =>
	import(/* webpackPrefetch: true */ /* webpackChunkName: "account" */ '@/views/core/requests/RequestsDetail.vue')
const RequestsList = () =>
	import(/* webpackPrefetch: true */ /* webpackChunkName: "account" */ '@/views/core/requests/RequestsList.vue')
const RequestCreateStep1 = () =>
	import(/* webpackPrefetch: true */ /* webpackChunkName: "new" */ '@/views/core/requests/steps/RequestCreateStep1.vue')
const RequestCreateStep2 = () =>
	import(/* webpackPrefetch: true */ /* webpackChunkName: "new" */ '@/views/core/requests/steps/RequestCreateStep2.vue')
const RequestCreateStep3 = () =>
	import(/* webpackPrefetch: true */ /* webpackChunkName: "new" */ '@/views/core/requests/steps/RequestCreateStep3.vue')
const RequestCreateStep4 = () =>
	import(/* webpackPrefetch: true */ /* webpackChunkName: "new" */ '@/views/core/requests/steps/RequestCreateStep4.vue')
const RequestCreateStep5 = () =>
	import(/* webpackPrefetch: true */ /* webpackChunkName: "new" */ '@/views/core/requests/steps/RequestCreateStep5.vue')
const RequestCreateStep6 = () =>
	import(/* webpackPrefetch: true */ /* webpackChunkName: "new" */ '@/views/core/requests/steps/RequestCreateStep6.vue')
const RequestCreateStep7 = () =>
	import(/* webpackPrefetch: true */ /* webpackChunkName: "new" */ '@/views/core/requests/steps/RequestCreateStep7.vue')
const RequestCreateStep8 = () =>
	import(/* webpackPrefetch: true */ /* webpackChunkName: "new" */ '@/views/core/requests/steps/RequestCreateStep8.vue')
const RequestCreateStep9 = () =>
	import(/* webpackPrefetch: true */ /* webpackChunkName: "new" */ '@/views/core/requests/steps/RequestCreateStep9.vue')
const ResponsesDetail = () =>
	import(/* webpackPrefetch: true */ /* webpackChunkName: "account" */ '@/views/core/responses/ResponsesDetail.vue')
const ResponsesList = () =>
	import(/* webpackPrefetch: true */ /* webpackChunkName: "account" */ '@/views/core/responses/ResponsesList.vue')
const StoriesDetail = () =>
	import(/* webpackPrefetch: true */ /* webpackChunkName: "service" */ '@/views/core/stories/StoriesDetail.vue')
const StoriesList = () =>
	import(/* webpackPrefetch: true */ /* webpackChunkName: "service" */ '@/views/core/stories/StoriesList.vue')

const Dashboard = () =>
	import(/* webpackPrefetch: true */ /* webpackChunkName: "profile" */ '@/views/profile/Dashboard.vue')
const Profile = () =>
	import(/* webpackPrefetch: true */ /* webpackChunkName: "profile" */ '@/views/profile/Profile.vue')
const ProfileInfo = () =>
	import(/* webpackPrefetch: true */ /* webpackChunkName: "profile" */ '@/views/profile/ProfileInfo.vue')
const ProfileNotifications = () =>
	import(/* webpackPrefetch: true */ /* webpackChunkName: "profile" */ '@/views/profile/ProfileNotifications.vue')
const ProfilePreferences = () =>
	import(/* webpackPrefetch: true */ /* webpackChunkName: "profile" */ '@/views/profile/ProfilePreferences.vue')
const ProfileSecurity = () =>
	import(/* webpackPrefetch: true */ /* webpackChunkName: "profile" */ '@/views/profile/ProfileSecurity.vue')

// Routes definition
const routes = [
	/*
	|--------------------------------------------------------------------------
	| Home
	|--------------------------------------------------------------------------
	*/

	{
		path: '/',
		name: 'home',
		component: Home,
	},

	/*
	|--------------------------------------------------------------------------
	| Navigation
	|--------------------------------------------------------------------------
	*/

	{
		path: '/chi-siamo',
		name: 'about',
		component: About,
	},
	{
		path: '/contatti',
		name: 'contacts',
		component: Contacts,
	},
	{
		path: '/executive-summary',
		name: 'executiveSummary',
		component: ExecutiveSummary,
	},
	{
		path: '/faq-avvocato',
		name: 'faqLawyer',
		component: FaqLawyer,
	},
	{
		path: '/faq-utente',
		name: 'faqUser',
		component: FaqUser,
	},
	{
		path: '/come-funziona-avvocato',
		name: 'howToLawyer',
		component: HowToLawyer,
	},
	{
		path: '/come-funziona-utente',
		name: 'howToUser',
		component: HowToUser,
	},
	{
		path: '/partners',
		name: 'partners',
		component: Partners,
	},
	{
		path: '/prezzi',
		name: 'pricing',
		component: Pricing,
	},
	{
		path: '/storie',
		name: 'storiesList',
		component: StoriesList,
	},
	{
		path: '/landing/:code',
		name: 'landingsDetail',
		component: LandingsDetail,
		props: true,
	},
	{
		path: '/avvocati/:code/storie/:slug',
		name: 'storiesDetail',
		component: StoriesDetail,
		props: true,
	},
	{
		path: '/avvocati/:code/:topic/:slug',
		name: 'articlesDetail',
		component: ArticlesDetail,
		props: true,
	},
	{
		path: '/avvocati/:code/:slug',
		name: 'articlesDetail',
		component: ArticlesDetail,
		props: true,
	},
	{
		path: '/avvocati/:code',
		name: 'requestTypesDetail',
		component: RequestTypesDetail,
		props: true,
	},
	{
		path: '/avvocati',
		name: 'requestTypesList',
		component: RequestTypesList,
		props: true,
	},
	{
		path: '/termini-e-condizioni',
		name: 'termsAndConditions',
		component: TermsAndConditions,
	},

	/*
	|--------------------------------------------------------------------------
	| Auth
	|--------------------------------------------------------------------------
	*/

	{
		path: '/login',
		name: 'login',
		component: Login,
		meta: {
			requiresVisitor: true,
		},
	},
	{
		path: '/logout',
		name: 'logout',
		component: Logout,
	},
	{
		path: '/mail-confirm-change/:key/:token',
		name: 'mailConfirmChange',
		component: MailConfirmChange,
		beforeEnter: (to, from, next) => {
			if (to.params.token !== undefined && !isNaN(to.params.token)) {
				// The "token" param have not to be a number (if so, redirect to error)
				next({ name: 'error', params: { code: Config.ERROR_PARAM_INVALID, info: 'token' } })
			}
			next()
		},
		props: true,
	},
	{
		path: '/mail-confirm-lawyer/:token',
		name: 'mailConfirmLawyer',
		component: MailConfirmLawyer,
		meta: {
			requiresVisitor: true,
		},
		beforeEnter: (to, from, next) => {
			if (to.params.token !== undefined && !isNaN(to.params.token)) {
				// The "token" param have not to be a number (if so, redirect to error)
				next({ name: 'error', params: { code: Config.ERROR_PARAM_INVALID, info: 'token' } })
			}
			next()
		},
		props: true,
	},
	{
		path: '/mail-confirm-user/:token',
		name: 'mailConfirmUser',
		component: MailConfirmUser,
		meta: {
			requiresVisitor: true,
		},
		beforeEnter: (to, from, next) => {
			if (to.params.token !== undefined && !isNaN(to.params.token)) {
				// The "token" param have not to be a number (if so, redirect to error)
				next({ name: 'error', params: { code: Config.ERROR_PARAM_INVALID, info: 'token' } })
			}
			next()
		},
		props: true,
	},
	{
		path: '/mail-notify',
		name: 'mailNotify',
		component: MailNotify,
		meta: {
			requiresVisitor: true,
		},
		props: true,
	},
	{
		path: '/recupero-password',
		name: 'passwordRecovery',
		component: PasswordRecovery,
		meta: {
			requiresVisitor: true,
		},
		props: true,
	},
	{
		path: '/reimposta-password/:token/:key',
		name: 'passwordReset',
		component: PasswordReset,
		meta: {
			requiresVisitor: true,
		},
		beforeEnter: (to, from, next) => {
			if (to.params.token !== undefined && !isNaN(to.params.token)) {
				// The "token" param have not to be a number (if so, redirect to error)
				next({ name: 'error', params: { code: Config.ERROR_PARAM_INVALID, info: 'token' } })
			} else if (to.params.key !== undefined && !isNaN(to.params.key)) {
				// The "key" param have not to be a number (if so, redirect to error)
				next({ name: 'error', params: { code: Config.ERROR_PARAM_INVALID, info: 'key' } })
			}
			next()
		},
		props: true,
	},
	{
		path: '/registrazione-avvocato',
		name: 'registerLawyer',
		component: RegisterLawyer,
		meta: {
			requiresVisitor: true,
		},
	},
	{
		path: '/registrazione-utente',
		name: 'registerUser',
		component: RegisterUser,
		meta: {
			requiresVisitor: true,
		},
	},

	/*
	|--------------------------------------------------------------------------
	| Reserved area
	|--------------------------------------------------------------------------
	*/

	{
		path: '/dashboard',
		name: 'dashboard',
		component: Dashboard,
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: '/credits',
		name: 'creditsList',
		component: CreditsList,
		meta: {
			requiresAuth: true,
			requiresLawyer: true,
		},
	},
	{
		path: '/feedbacks',
		name: 'feedbacksList',
		component: FeedbacksList,
		meta: {
			requiresAuth: true,
			requiresLawyer: true,
		},
	},
	{
		path: '/messages',
		name: 'messagesList',
		component: MessagesList,
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: '/requests/:id',
		name: 'requestsDetail',
		component: RequestsDetail,
		meta: {
			requiresAuth: true,
		},
		beforeEnter: (to, from, next) => {
			if (to.params.id !== undefined && isNaN(to.params.id)) {
				// The "id" param have to be a number (if not, redirect to error)
				next({ name: 'error', params: { code: Config.ERROR_PARAM_INVALID, info: 'id' } })
			}
			next()
		},
		props: true,
	},
	{
		path: '/requests',
		name: 'requestsList',
		component: RequestsList,
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: '/responses/:id',
		name: 'responsesDetail',
		component: ResponsesDetail,
		meta: {
			requiresAuth: true,
		},
		beforeEnter: (to, from, next) => {
			if (to.params.id !== undefined && isNaN(to.params.id)) {
				// The "id" param have to be a number (if not, redirect to error)
				next({ name: 'error', params: { code: Config.ERROR_PARAM_INVALID, info: 'id' } })
			}
			next()
		},
		props: true,
	},
	{
		path: '/responses',
		name: 'responsesList',
		component: ResponsesList,
		meta: {
			requiresAuth: true,
		},
		props: true,
	},
	{
		path: '/request/create/1',
		name: 'requestCreateStep1',
		component: RequestCreateStep1,
		beforeEnter: (to, from, next) => {
			if (store.getters.loggedIn && !store.getters.isUser) {
				// Access forbidden for "lawyers"
				next({ name: 'error', params: { code: Config.ERROR_FORBIDDEN_ACCESS_TYPE, info: 'RequiresUser' } })
			}
			next()
		},
	},
	{
		path: '/request/create/2',
		name: 'requestCreateStep2',
		component: RequestCreateStep2,
		beforeEnter: (to, from, next) => {
			if (store.getters.loggedIn && !store.getters.isUser) {
				// Access forbidden for "lawyers"
				next({ name: 'error', params: { code: Config.ERROR_FORBIDDEN_ACCESS_TYPE, info: 'RequiresUser' } })
			}
			next()
		},
	},
	{
		path: '/request/create/3',
		name: 'requestCreateStep3',
		component: RequestCreateStep3,
		beforeEnter: (to, from, next) => {
			if (store.getters.loggedIn && !store.getters.isUser) {
				// Access forbidden for "lawyers"
				next({ name: 'error', params: { code: Config.ERROR_FORBIDDEN_ACCESS_TYPE, info: 'RequiresUser' } })
			}
			next()
		},
	},
	{
		path: '/request/create/4',
		name: 'requestCreateStep4',
		component: RequestCreateStep4,
		beforeEnter: (to, from, next) => {
			if (store.getters.loggedIn && !store.getters.isUser) {
				// Access forbidden for "lawyers"
				next({ name: 'error', params: { code: Config.ERROR_FORBIDDEN_ACCESS_TYPE, info: 'RequiresUser' } })
			}
			next()
		},
	},
	{
		path: '/request/create/5',
		name: 'requestCreateStep5',
		component: RequestCreateStep5,
		beforeEnter: (to, from, next) => {
			if (store.getters.loggedIn && !store.getters.isUser) {
				// Access forbidden for "lawyers"
				next({ name: 'error', params: { code: Config.ERROR_FORBIDDEN_ACCESS_TYPE, info: 'RequiresUser' } })
			}
			next()
		},
	},
	{
		path: '/request/create/6',
		name: 'requestCreateStep6',
		component: RequestCreateStep6,
		beforeEnter: (to, from, next) => {
			if (store.getters.loggedIn && !store.getters.isUser) {
				// Access forbidden for "lawyers"
				next({ name: 'error', params: { code: Config.ERROR_FORBIDDEN_ACCESS_TYPE, info: 'RequiresUser' } })
			}
			next()
		},
	},
	{
		path: '/request/create/7',
		name: 'requestCreateStep7',
		component: RequestCreateStep7,
		beforeEnter: (to, from, next) => {
			if (store.getters.loggedIn && !store.getters.isUser) {
				// Access forbidden for "lawyers"
				next({ name: 'error', params: { code: Config.ERROR_FORBIDDEN_ACCESS_TYPE, info: 'RequiresUser' } })
			}
			next()
		},
	},
	{
		path: '/request/create/8',
		name: 'requestCreateStep8',
		component: RequestCreateStep8,
		beforeEnter: (to, from, next) => {
			if (store.getters.loggedIn && !store.getters.isUser) {
				// Access forbidden for "lawyers"
				next({ name: 'error', params: { code: Config.ERROR_FORBIDDEN_ACCESS_TYPE, info: 'RequiresUser' } })
			}
			next()
		},
	},
	{
		path: '/request/create/9',
		name: 'requestCreateStep9',
		component: RequestCreateStep9,
		beforeEnter: (to, from, next) => {
			if (store.getters.loggedIn && !store.getters.isUser) {
				// Access forbidden for "lawyers"
				next({ name: 'error', params: { code: Config.ERROR_FORBIDDEN_ACCESS_TYPE, info: 'RequiresUser' } })
			}
			next()
		},
	},

	/*
	|--------------------------------------------------------------------------
	| Profile area
	|--------------------------------------------------------------------------
	*/

	{
		path: '/profile',
		name: 'profile',
		component: Profile,
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: '/profile/info',
		name: 'profileInfo',
		component: ProfileInfo,
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: '/profile/notifications',
		name: 'profileNotifications',
		component: ProfileNotifications,
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: '/profile/preferences',
		name: 'profilePreferences',
		component: ProfilePreferences,
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: '/profile/security',
		name: 'profileSecurity',
		component: ProfileSecurity,
		meta: {
			requiresAuth: true,
		},
	},

	/*
	|--------------------------------------------------------------------------
	| Miscellaneous
	|--------------------------------------------------------------------------
	*/

	{
		path: '/newsletter/unsubscribe',
		name: 'newsletterUnsubscribe',
		component: NewsletterUnsubscribe,
	},

	/*
	|--------------------------------------------------------------------------
	| Error routes
	|--------------------------------------------------------------------------
	*/

	{
		path: '/error',
		name: 'error',
		component: PageError,
		props: true,
	},

	/*
	|--------------------------------------------------------------------------
	| Not handled routes (page not found)
	|--------------------------------------------------------------------------
	*/

	{
		path: '*',
		name: 'pageNotFound',
		component: PageNotFound,
	},
]

export default routes



// WEBPACK FOOTER //
// ./src/router/index.js